import axios from "axios";
import { getCsrfToken } from "./utils";

const checkResponse = (response) => {
  if (!response.data.success) throw new Error("Operation failed.");
};

export const index = async () => {
  const request = {
    url: "/api/favourite-colours",
  };

  const response = await axios(request);

  return response.data.data;
};

export const toggleItem = async (item) => {
  const request = {
    url: "/actions/wishlist/items/toggle",
    method: "post",
    data: {
      ...getCsrfToken(),
      elementId: item.id,
      listTypeHandle: "favouriteColours",
    },
  };

  const response = await axios(request);

  checkResponse(response);

  return response.data.items;
};

export const addItem = async (item) => {
  const request = {
    url: "/actions/wishlist/items/add",
    method: "post",
    data: {
      ...getCsrfToken(),
      elementId: item.id,
      listTypeHandle: "favouriteColours",
    },
  };

  const response = await axios(request);

  checkResponse(response);

  return response.data.items;
};

export const removeItem = async (item) => {
  const request = {
    url: "/actions/wishlist/items/remove",
    method: "post",
    data: {
      ...getCsrfToken(),
      elementId: item.id,
      listTypeHandle: "favouriteColours",
    },
  };

  const response = await axios(request);

  checkResponse(response);

  return response.data.items;
};
